import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { LegalPage } from '@/components/generals/legal-page'

const SECTIONS = [
    {
        id: 'using-verdane',
        title: 'Your use of Verdane',
        body: [
            'Opening an account or using this site means you accept these terms. You need to be 18 or older, and the details you give us when you sign up must be accurate.',
            'Keep your password to yourself. You are responsible for what happens on your account, and you should let us know right away if you believe someone else has used it.'
        ]
    },
    {
        id: 'guidance',
        title: 'Information, not guarantees',
        body: [
            'Responses from the Verdane AI, our calculators and our demo are for education. They rely on simplified assumptions and do not recommend buying or selling any security.',
            'Personal advice is given by our licensed advisors during the calls you book, based on the full picture you share with them.'
        ]
    },
    {
        id: 'calls',
        title: 'Advisor calls',
        body: [
            'Your first advisor call is free. You can cancel any upcoming call from your account whenever you need to. All times are shown in US Eastern Time.',
            'If an advisor has to reschedule, our team will reach you at the email address you gave us.'
        ]
    },
    {
        id: 'plans',
        title: 'Plans and free trials',
        body: [
            'The Free plan never expires. Paid plans begin with a 14-day free trial that requires no card. You can change or cancel your plan at any time.'
        ]
    },
    {
        id: 'disclosures',
        title: 'Important disclosures',
        body: [
            'Investing always carries risk, including the possible loss of principal. Past performance is no guarantee of future results, and forecasts are estimates that may not come to pass.',
            'Examples, testimonials and figures shown on this site are for illustration only. Your own results will depend on your circumstances.'
        ]
    },
    {
        id: 'contact',
        title: 'Get in touch',
        body: [
            <>If anything here needs explaining, write to us through the <Link href='/contact' className='text-cream underline decoration-cream/30 underline-offset-4'>contact page</Link>. A real person will answer within one business day.</>
        ]
    }
]

const Terms: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo title='Terms of use' description='The terms for using Verdane, booking calls with advisors and choosing a plan, along with the investment disclosures that matter.' />

            <LegalPage
                eyebrow='Terms'
                title='Our terms, *simply said*'
                intro='What you can count on from us, what we ask in return and the disclosures that come with any financial guidance.'
                updated='October 2026'
                sections={SECTIONS}
            />
        </Layout>
    )
}

export default Terms
